const qk = {
  members: (orgId: string) => ["orgs", orgId, "members"] as const,
  member: (orgId: string, memberId: string) =>
    [qk.members(orgId), memberId] as const,
  invite: (orgId: string) => ["orgs", orgId, "invite"] as const,
  domains: (orgId: string) => ["orgs", orgId, "domains"] as const,
  linearCleanupIssueCandidates: (orgId: string) =>
    ["orgs", orgId, "linear-cleanup-issue-candidates"] as const,
  apiKeys: (orgId: string, appId?: string) =>
    appId
      ? (["orgs", orgId, "api-keys", appId] as const)
      : (["orgs", orgId, "api-keys"] as const),
};

export { qk as orgQueryKeys };
